var CsAgGridJsService = /** @class */ (function () {
    function CsAgGridJsService() {
        this.updateNodeCellValue = function (rowNode, rowData) {
            if (rowData) {
                Object.entries(rowData).forEach(function (_a) {
                    var key = _a[0], val = _a[1];
                    return rowNode['setDataValue'](key, val);
                });
            }
        };
    }
    return CsAgGridJsService;
}());
export { CsAgGridJsService };
